export default "__VITE_ASSET__fcef537b__"